module.exports = __webpack_public_path__ + "static/media/RAS_FINAL.cd3012e9.png";